import { useRef, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { useContext } from "react";
import TurnoPresencialIcon from "../../../assets/images/generico/TurnoPresencialIcon";
import TurnoVideoConsultaIcon from "../../../assets/images/generico/TurnoVideoConsultaIcon";
import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import { amOrPm } from "../../../../global/utils/amOrPm";
import "./CardMedico.css";
import { FaStar } from "react-icons/fa";
import camelize from "../../../../global/utils/camelize";

const CardMedicoOLD = ({
  idturno,
  Encuesta,
  estrellas_medico,
  estrellas_recepcion,
  Fecha,
  Hora,
  Medico,
  Tecnico,
  Especialidad,
  videoConsulta,
  onClickModal,
  IdPaciente,
  IdPacienteDesc,
  idProtocolo,
}) => {
  const { misMedicosState } = useContext(PortalContext);
  const trackButton = useRef();
  const [valorActualEstrellas, setValorActualEstrellas] =
    useState(estrellas_medico);
  const [valorMedico, setValorMedico] = useState(null);
  const [valorRecepcionista, setValorRecepcionista] = useState(null);
  const [valorTecnico, setValorTecnico] = useState(null);

  const stars = Array(5).fill(0);

  const starColor = {
    dorado: "#DBC500",
    azul: "#0072B3",
    gris: "#E6E6E6",
  };

  const imgTittle =
    videoConsulta === true ? (
      <TurnoVideoConsultaIcon />
    ) : (
      <TurnoPresencialIcon />
    );

  useEffect(() => {
    if (Encuesta) {
      if (
        misMedicosState.misMedicos.data &&
        misMedicosState.misMedicos.data !== ""
      ) {
        setValorMedico(Encuesta.estrellas_medico);
        setValorRecepcionista(Encuesta.estrellas_recepcion);
        setValorTecnico(Encuesta.estrellas_tecnico);
      }
    } else {
      //limpio estados en caso de llegar null en encuesta, evito que queden datos cargados
      setValorMedico(null);
      setValorRecepcionista(null);
      setValorTecnico(null);
    }
    // eslint-disable-next-line
  }, [Encuesta]);

  return (
    <div className="ptur-misMedicos2-card" ref={trackButton}>
      <div className="ptur-misMedicos2-titulo">
        <div className="ptur-misMedicos2-especialidad">
          <span>{imgTittle}</span>
          <p className="rb18b">{Especialidad}</p>
        </div>
        {/* <div className="ptur-misMedicos2-paciente">
          {authState.auth.data.paciente.codigo === IdPaciente ? (
            ""
          ) : (
            <p className="rb18b">{camelize(IdPacienteDesc)}</p>
          )}
        </div> */}
      </div>
      <div className="ptur-misMedicos2-card-cuerpo">
        <li className="ptur-misMedicos2-fecha rb16b">
          {getDiaStrTurno(Fecha)}
          <span className="rb16l">{getDiaStrTurno(Fecha, true)}</span>
        </li>
        {idProtocolo > 0 ? (
          <>
            {Tecnico !== null ? (
              <li className="ptur-misMedicos2-turnoSolicitado">
                Técnico: <span className="rb16b">{camelize(Tecnico)}</span>
              </li>
            ) : (
              ""
            )}
          </>
        ) : (
          <>
            <li className="ptur-misMedicos2-turnoSolicitado">
              Horario:{" "}
              <span className="rb16b">
                {Hora} {amOrPm(Hora)}
              </span>
            </li>
            <li className="ptur-misMedicos2-turnoSolicitado">
              {Tecnico ? "Técnico:" : "Médico:"}{" "}
              {Tecnico ? (
                <span className="rb16b">{camelize(Tecnico)}</span>
              ) : (
                <span className="rb16b">{camelize(Medico)}</span>
              )}
            </li>
          </>
        )}
        {/* FALTA ANALIZAR QUE FUNCION TENDRA. LO DEJO COMENTADO POR EL MOMENTO */}
        {/* <div className="ptur-misMedicos2-botonTurno">
          <button className="ptur-misMedicos2-botonTurno-texto rb16m">
            Buscar un turno similar
          </button>
        </div> */}
      </div>
      <div className="ptur-misMedicos2-pie">
        <div className="ptur-misMedicos2-estrellas-boton-container">
          <div className="ptur-misMedicos2-estrellas-container">
            {stars.map((_, index) => {
              return (
                <div
                  key={index}
                  style={{ cursor: "unset" }}
                  className={
                    (Tecnico === null || Tecnico === ""
                      ? Medico == null || Medico === ""
                        ? valorRecepcionista
                        : valorMedico
                      : valorTecnico) > index
                      ? "ptur-misMedicos2-estrellas-dorado"
                      : "ptur-misMedicos2-estrellas"
                  }
                >
                  <FaStar
                    key={index}
                    size={18}
                    color={
                      (Tecnico === null || Tecnico === ""
                        ? Medico == null || Medico === ""
                          ? valorRecepcionista
                          : valorMedico
                        : valorTecnico) > index
                        ? starColor.dorado
                        : starColor.azul
                    }
                  />
                </div>
              );
            })}
          </div>
          <div className="ptur-misMedicos2-botonCalificar">
            {Encuesta !== null ? (
              <button
                onClick={onClickModal}
                className="ptur-misMedicos2-botonCalificar-texto rb16m"
              >
                Modificar
              </button>
            ) : (
              <button
                onClick={onClickModal}
                className="ptur-misMedicos2-botonCalificar-texto rb16m"
              >
                Calificar
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardMedicoOLD;
